import { render, staticRenderFns } from "./ProviderProfileEmbed.vue?vue&type=template&id=7c113df1&"
import script from "./ProviderProfileEmbed.vue?vue&type=script&lang=js&"
export * from "./ProviderProfileEmbed.vue?vue&type=script&lang=js&"
import style0 from "./ProviderProfileEmbed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports